document.addEventListener('DOMContentLoaded', function () {
  // Respect users who prefer reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const elements = document.querySelectorAll('.typewriter');

  if (!elements.length) return;

  // If reduced motion is preferred, just show text normally, skip animation
  if (prefersReducedMotion) {
    elements.forEach(el => el.classList.add('typewriter--done'));
    return;
  }

  const speed = 35; // ms per character - adjust to taste

  const typeText = (el) => {
    const originalText = el.getAttribute('data-text') || el.textContent;
    el.setAttribute('data-text', originalText);
    el.textContent = '';
    el.classList.add('typewriter--active');

    let i = 0;
    const interval = setInterval(() => {
      el.textContent += originalText[i];
      i++;
      if (i >= originalText.length) {
        clearInterval(interval);
        el.classList.remove('typewriter--active');
        el.classList.add('typewriter--done');
      }
    }, speed);
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        typeText(entry.target);
        obs.unobserve(entry.target); // only run once per element
      }
    });
  }, {
    threshold: 0.4 // triggers when 40% of element is visible
  });

  elements.forEach(el => observer.observe(el));
});
